import React from "react";
import styled from "styled-components/native";

import { Spacer } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { TouchableOpacity } from "react-native-gesture-handler";
import LabelView from "../LabelView";
import { MatchLabelContainerProps } from "./types";
import { Platform } from "react-native";
import FooterModel from "../FooterModel/FooterModel";
import { css } from "styled-components/native";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";

const MatchLabelView = ({
  testID,
  centerIcon,
  ceterIconTheme,
  keyWidthPercent,
  keyTypographyStyle,
  itemLeftTextTheme,
  keyMargin = 0,
  itemContent = "start",
  leftKey,
  leftValue,
  rightKey,
  rightValue,
  leftDirection,
  addSpacer = false,
  hideDivider = false,
  dividerPadding = 12,
  showPadding = false,
  SwitchStoneCallback,
  clickable,
  rightPrefixTextTheme,
  availabilityIcon,
  OtherDetail,
  currentIndex,
  setCurrentIndex,
  isFromMatchPair,
}: MatchLabelContainerProps) => {
  const { t, theme } = useScreenOptionsHooks();
  return (
    <ContainerView testID={testID}>
      <FlexMainView>
        <MainContainerView>
          <LeftLabelContainer
            keyMargin={keyMargin}
            itemContent={itemContent}
            keyWidthPercent={keyWidthPercent}
          >
            <LabelView
              itemLeftText={leftKey}
              itemRightText={leftValue}
              direction={leftDirection}
              keyTypographyStyle={keyTypographyStyle}
              itemLeftTextTheme={itemLeftTextTheme}
              clickableHandle={clickable}
              rightPrefixTextTheme={rightPrefixTextTheme}
              availabilityIcon={availabilityIcon}
              ellipsize={false}
              isFromMatchPair={isFromMatchPair}
            />
          </LeftLabelContainer>
          {!hideDivider && <Divider />}
        </MainContainerView>
        {theme.isLargeScreen && <Spacer size={SpaceType.Size_60} />}
        <CenterIconAlignView>
          <TouchableOpacity onPress={() => SwitchStoneCallback()}>
            <VDBIcon
              name={centerIcon}
              size={24}
              color={ceterIconTheme}
              variant={IconsVariant.VDBCustom}
            />
          </TouchableOpacity>
        </CenterIconAlignView>
        {theme.isLargeScreen && <Spacer size={SpaceType.Big} />}
        {addSpacer && (
          <CenterIconAlignView>
            <Spacer size={SpaceType.Big} />
          </CenterIconAlignView>
        )}
        <MainContainerView>
          <RightLabelContainer itemContent={itemContent} keyMargin={keyMargin}>
            <LabelView
              itemLeftTextTheme={itemLeftTextTheme}
              itemLeftText={rightKey}
              itemRightText={rightValue}
              direction={leftDirection}
              keyTypographyStyle={keyTypographyStyle}
              clickableHandle={clickable}
              rightPrefixTextTheme={rightPrefixTextTheme}
              availabilityIcon={availabilityIcon}
              ceterIconTheme={ceterIconTheme}
              ellipsize={false}
              isFromMatchPair={isFromMatchPair}
            />
            {theme.isLargeScreen ? (
              <FooterModel
                OtherDetail={OtherDetail}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
                ceterIconTheme={ceterIconTheme}
                centerString={t(
                  "findMatch.showingItemsCount.outOf.text",
                  "out of"
                )}
                preText={t(
                  "findMatch.showingItemsCount.showing.text",
                  "Showing"
                )}
                postText={t("findMatch.showingItemsCount.found.text", "Found")}
              />
            ) : null}
          </RightLabelContainer>
          {showPadding && <DividerContainer dividerPadding={dividerPadding} />}
          {!hideDivider && <Divider />}
        </MainContainerView>
      </FlexMainView>
    </ContainerView>
  );
};
const ContainerView = styled.View<any>`
  flex-direction: row;
  width: 100%;
`;

const MainContainerView = styled.View<any>`
  flex-direction: column;
  ${({ theme }) =>
    !theme.isLargeScreen &&
    css`
      justify-content: space-between;
    `}
  flex: 1;
  flex-basis: ${() => (Platform.OS === "web" ? "auto" : "1")};
  max-width: ${({ theme }) => (theme.isLargeScreen ? "40%" : "47%")};
`;

const FlexMainView = styled.View<any>`
  flex-direction: row;
  ${({ theme }) =>
    !theme.isLargeScreen &&
    css`
      justify-content: space-between;
    `}
  flex: 1;
  flex-basis: auto;
`;

const LeftLabelContainer = styled.View<any>`
  align-items: center;
  flex-direction: row;
  justify-content: ${({ itemContent }) => itemContent};
  ${({ theme, keyMargin }) =>
    !theme.isLargeScreen &&
    css`
      margin: ${keyMargin}px;
    `}
  ${({ theme, keyMargin }) =>
    theme.isLargeScreen &&
    css`
      margin-top: ${keyMargin}px;
    `}
`;
const RightLabelContainer = styled.View<any>`
  flex-direction: row;
  align-items: center;
  justify-content: ${({ itemContent }) => itemContent};
  margin: ${({ keyMargin }) => keyMargin}px;
`;

const DividerContainer = styled.View`
  padding: ${({ dividerPadding }) => dividerPadding}px;
`;

const CenterIconAlignView = styled.View<any>`
  justify-content: center;
`;

const Divider = styled.View`
  height: 1px;
  flex-direction: row;
  background-color: ${({ theme }) => theme["core-04"]};
  width: 100%;
  max-width: 100%;
`;

export default MatchLabelView;
